export const DataMutationMyBag_GiftcardRemove_QueryKey = {
  mybagGiftcardRemove: (): string => {
    const queryKey = "data-mutation-mybag-giftcard-remove";
    return queryKey;
  },
};
